<div class="blue_theme" [class.light-theme]="themeMode === 'light'" [class.dark-theme]="themeMode === 'dark'" dir="ltr">
  <!-- Top Strip -->
  <app-topstrip (toggleSidenav)="leftsidenav.toggle()"></app-topstrip>

  <mat-sidenav-container class="mainWrapper" autosize autoFocus>

    <!-- ============================================================== -->
    <!-- Vertical Sidebar -->
    <!-- ============================================================== -->
    <mat-sidenav
      #leftsidenav
      [mode]="isOver ? 'over' : 'side'"
      [opened]="!isOver"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav"
      >
      <div class="flex-layout">
        <!-- <app-branding></app-branding> -->

        <ng-scrollbar class="position-relative" style="height: 100%">
          <mat-nav-list class="sidebar-list">
            @for (item of filteredNavItems; track item) {
              <app-nav-item
                [item]="item"
                (notify)="leftsidenav.toggle()"
              ></app-nav-item>
            }
          </mat-nav-list>
        </ng-scrollbar>

        <!-- Logout / Promo Panel -->
        <div class="p-20">
          <div class="bg-light-primary d-flex align-items-center rounded p-20">
            <div>
              <h5 class="mat-subtitle-1 f-s-16 f-w-600 m-b-8">
                Want to <br />quit?
              </h5>
              <button mat-flat-button color="primary" (click)="logout()"
                class="d-flex justify-content-center">
                Logout
              </button>
            </div>
            <div class="side-img m-l-auto">
              <img src="./assets/images/backgrounds/rupee.png" alt="image" width="90" />
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="contentWrapper" #content>
      <!-- Header -->
      <app-header
        [showToggle]="!isOver"
        (toggleCollapsed)="toggleCollapsed()"
        (toggleMobileNav)="leftsidenav.toggle()"
      ></app-header>

      <!-- Page Outlet -->
      <div class="body-wrapper">
        <main class="pageWrapper maxWidth">
          <router-outlet></router-outlet>
        </main>
      </div>

    </mat-sidenav-content>

  </mat-sidenav-container>
  <app-footer></app-footer>

</div>
